import { ENGAGEMENT_CATALOG, ESCALATION_CATALOG, PROMPT_MANAGEMENT_CATALOG } from 'skipify-types';

import { AgenticAgentSettingsCreate } from '../../store/modules/merchant/types';
import { DEFAULT_AGENT_SELECTOR } from './agentSelector';

export type DefaultEllaCreateOptions = {
  /** When false, default checkout to handoff so create/enable without PSP does not hit MMS 422. */
  hasDefaultPaymentCredential?: boolean;
};

/** Default Ella agent payload for POST /merchants/{id}/agentic-settings (enable flow). */
export const getDefaultEllaCreateSettings = (
  overrides?: Partial<AgenticAgentSettingsCreate>,
  options?: DefaultEllaCreateOptions,
): AgenticAgentSettingsCreate => ({
  promptManagement: {
    formality: 'professional',
    sentenceStyle: 'balanced',
    customGreeting: 'shopping-concierge',
    brandVocabulary: {
      mirrorSiteTerminology:
        PROMPT_MANAGEMENT_CATALOG.brandVocabulary.mirrorSiteTerminology.default,
    },
    suggestedPrompts: [],
  },
  voice: {
    pronunciationGlossary: [],
  },
  productExperience: {
    productDisplay: 'In_Chat',
    agentSelector: DEFAULT_AGENT_SELECTOR,
  },
  engagement: {
    intrusiveness: ENGAGEMENT_CATALOG.intrusiveness.default,
    upsellPosture: 'balanced',
    confidencePosture: 'standard',
    proactiveness: 'balanced',
  },
  escalation: {
    threshold: ESCALATION_CATALOG.escalationThreshold.default,
    operatingHours: 'business-hours',
    instruction: 'Direct the shopper to call our support phone number for assistance',
  },
  checkoutMode: {
    mode: options?.hasDefaultPaymentCredential === false ? 'handoff' : 'inline',
  },
  rules: [],
  support: {
    enabled: false,
  },
  knowledgeBase: {
    enabled: false,
  },
  ...overrides,
});
